import { ContainerModule, WebuiIocKey } from '@ztechapps/webui.contract'
import { CompanySelect } from './CompanySelect'

export const companyContainer = new ContainerModule((bind) => {
  bind(WebuiIocKey.company.companySelect).to(CompanySelect)
})
